import { updateReview } from "../../../../actions/siteadmin/WhyHostReview/deleteWhyHostReview";
import showToaster from "../../../../helpers/showToaster";

import { containsMalicious } from "../../../../helpers/textRestriction";

async function submit(values, dispatch) {
  const fieldsToValidate = ["userName", "reviewContent"];
  for (const field of fieldsToValidate) {
    if (values[field] && containsMalicious(values[field])) {
      showToaster({ messageId: "invalidInput", toasterType: "error" });
      return;
    }
  }

  if (values.image == null) {
    showToaster({ messageId: "uploadImage", toasterType: "error" });
    return;
  }

  dispatch(updateReview(values));
}

export default submit;
